export default {
    BLOCK: 'BLOCK',
    UNBLOCK: 'UNBLOCK',
    UNKNOWN: 'UNKNOWN',
    SEARCH: 'SEARCH',
    GET_STATS: 'GET_STATS',
    GET_REFFERED_USERS: 'GET_REFFERED_USERS',
};
